import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { Constant, NumberOfEntry } from 'src/app/@shared/constants/Constant';
import { ICateringLogOutputModel } from 'src/app/shared/interfaces/catering-log-output.interface';
import { CateringService } from '../catering.service';

@Component({
  selector: 'app-catering-logs',
  templateUrl: './catering-logs.component.html',
  styleUrls: ['./catering-logs.component.scss'],
})
export class CateringLogsComponent implements OnInit, OnDestroy {
  @Input() serviceRequestId: string;
  @Output() cateringLogsLength = new EventEmitter<number>();

  private _subscriptions: Subscription = new Subscription();
  cateringLogs: ICateringLogOutputModel[];
  selectedPageEntries: number = NumberOfEntry[0];
  numberOfEntries: number[] = NumberOfEntry;
  searchCateringLogs: string;
  currentPage: number;
  pagination: string;
  sortOrder: boolean;
  cateringLogsSortBy: string;
  legNumber: boolean;
  cateringNumber: boolean;
  legOrigin: boolean;
  legDestination: boolean;
  previousStatus: boolean;
  updatedStatus: boolean;
  createdOn: boolean;
  createdBy: boolean;
  updatedOn: boolean;
  updatedBy: boolean;
  operationType: boolean;
  previousValues: boolean;
  currentValues: boolean;
  constructor(
    private _cateringService: CateringService,
    private _toast: ToastrService,
  ) {}

  ngOnInit(): void {
    this.getCateringLogs(this.serviceRequestId);
  }

  ngOnDestroy(): void {
    this._subscriptions.unsubscribe();
  }

  private getCateringLogs(serviceRequestId: string): void {
    this._subscriptions.add(
      this._cateringService.getCateringLogsByServiceRequestId(serviceRequestId).subscribe(
        (response) => {
          this.cateringLogs = response.data ?? [];
          this.pagination = Constant.showPaginationMessage(this.cateringLogs.length, this.currentPage, this.selectedPageEntries);
          this.cateringLogsLength.emit(this.cateringLogs.length);
        },
        () => {
          this._toast.warning('Unable to retrieve the catering logs!', 'Warning', { timeOut: 6000, positionClass: 'toast-top-center' });
        },
      ),
    );
  }

  updatePagination(): void {
    this.currentPage = 1;
    this.pagination = Constant.showPaginationMessage(this.cateringLogs.length, this.currentPage, this.selectedPageEntries);
  }

  currentPageChange(event): void {
    this.currentPage = event;
    this.pagination = Constant.showPaginationMessage(this.cateringLogs.length, this.currentPage, this.selectedPageEntries);
  }
}
